<template>
    <div class="pt-3 integration-mapping">

        <div class="d-flex p-3">
            <v-spacer></v-spacer>
            <div class="share-lookup d-flex flex-column flex-md-row">
                <v-btn @click="onShareLookup" small color="secondary">{{ valueLookupShareText }}</v-btn>
            </div>
        </div>
        <div v-if="!is_view" class="add-lookup-wrapper p-3 d-flex">
            <v-spacer></v-spacer>
            <div class="add-lookup">
                <h5 class="subtitle-2">Machship Fields</h5>
                <div class="d-flex flex-column flex-md-row">
                    <v-combobox
                        outlined
                        dense
                        :items="machshipFields"
                        v-model="selectField"
                        class="mr-3">
                    </v-combobox>
                    <v-btn @click="onAddLookupTable" color="primary">Add Lookup Table</v-btn>
                </div>
            </div>
        </div>


        <v-form
            v-if="items"
            ref="form"
            v-model="valid"
            class="p-3 pt-0"
            @submit="onSubmit"
            :disabled="is_view">

            <v-container fluid v-if="Object.keys(items).length > 0">
                <v-row
                    v-for="(item, index) in items"
                    :key="'item-' + index"
                    class="mt-5">
                    <!-- machship_field -->
                    <v-col sm="12" class="overflow-auto">
                        <div v-if="!is_view" class="pb-3 d-flex">
                            <v-spacer></v-spacer>
                            <v-btn fab dark color="orange" @click="onRemoveLookupTable(index)">
                                <v-icon dark>mdi-minus</v-icon>
                            </v-btn>
                        </div>
                        <label class="mt-3"><b>{{ index }}</b> Lookup Table</label>
                        <table class="table-valuelookups table table-hover">
                            <thead>
                                <tr>
                                    <th>From</th>
                                    <th>From Label</th>
                                    <th>To</th>
                                    <th>To Label</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(lookup, i) in item"
                                    :key="'item-lookup-' + i"
                                    class="table-valuelookups-row"
                                >
                                    <td>
                                        <v-text-field flat dense v-model="lookup.from_value" :readonly="is_view">
                                        </v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field flat dense v-model="lookup.from_label" :readonly="is_view">
                                        </v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field flat dense v-model="lookup.to_value" :readonly="is_view">
                                        </v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field flat dense v-model="lookup.to_label" :readonly="is_view">
                                        </v-text-field>
                                        <span class="ic-remove clickable" @click="() => onClearRow(lookup)">
                                            <i class="fa fa-times-circle fa-2x"></i>
                                        </span>
                                    </td>
                                </tr>
                                <tr v-if="!is_view" class="table-valuelookups-row">
                                    <td>
                                        <v-text-field :ref="'new-' + index + '-from_value'" flat dense @change="onChangeNew($event, 'from_value', index)"></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field :ref="'new-' + index + '-from_label'" flat dense @change="onChangeNew($event, 'from_label', index)"></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field :ref="'new-' + index + '-to_value'" flat dense @change="onChangeNew($event, 'to_value', index)"></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field :ref="'new-' + index + '-to_label'" flat dense @change="onChangeNew($event, 'to_label', index)"></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row v-if="!is_view">
                    <v-col>
                        <div class="mt-5 text-right">
                            <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit">
                                <span v-if="isSubmit">
                                    <v-progress-circular
                                        indeterminate
                                        size="12"
                                        width="2"
                                        color="green darken-3">
                                    </v-progress-circular>
                                    Updating..
                                </span>
                                <span v-else>Update</span>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
            <p v-else>No value lookups at the moment.</p>
        </v-form>
        <v-progress-linear
            v-else
            indeterminate
            color="primary"
            class="mb-5">
        </v-progress-linear>
        <Modal
            ref="modal"
            color="error"
            okText="delete"
            cancelText="Close"
         />
    </div>
</template>

<script>
import Modal from '~/Modal'
import { EventBus } from '@/js/event-bus.js'
import Vue from 'vue'

export default {
    components: {
        Modal
    },

    props: {
        id: { type: Number, default: null },
        direction: { type: String, default: 'from_machship' },
        is_view: { type: Boolean, default: false }
    },

    data() {
        return {
            isSubmit: false,
            valid: false,
            items: [],
            machshipFields: [],
            selectField: '',
            type: 'number',
            valueLookupShareText: "Share Look Up"
        }
    },

    created() {
        this.items = null
        this.fetchIntegration()
        this.fetchOptions()
    },

    computed: {
        target () {
            const value = this[this.type]
            if (!isNaN(value)) return Number(value)
            else return value
          }
    },

    methods: {
        onShareLookup() {
            let format = '';
            this.valueLookupShareText = "Fetching...";
            this.$http
                .get('/api/valuelookups/share/' + this.id)
                .then(({ data }) => {
                    format = data.format;
                    navigator.clipboard.writeText(format);
                    EventBus.$emit('show-success', 'Successfully copied to clipboard.');
                    this.valueLookupShareText = "Share Look Up";
                })
                .catch(err => {
                    this.valueLookupShareText = "Share Look Up";
                    EventBus.$emit('show-error', err);
                })
        },

        onAddLookupTable() {
            if (!this.items[this.selectField]) {
                Vue.set(this.items, this.selectField, [])
                setTimeout(() => {
                    let refs = this.$refs['new-' + this.selectField + '-from_value'][0]
                    this.$vuetify.goTo(refs, {
                        duration: 300,
                        offset: 0,
                        easing: 'easeInOutCubic',
                    })
                    refs.focus()
                }, 100)
            }
        },

        onRemoveLookupTable(machship_field) {

            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want to delete ' + machship_field + ' value lookup?',
                () => this.onConfirmedRemove(machship_field)
            );
        },

        onConfirmedRemove(machship_field) {
            // we need to delete this by bulk
            let items = this.items[machship_field]
                            .filter(item => item.id)
                            .map(item => item.id)

            this.$http
                .post('api/valuelookups/removes',  items)
                .then(res => {
                    Vue.delete(this.items, machship_field)
                    EventBus.$emit('show-success', 'Successfully deleted ' + machship_field + ' value lookup.')
                })
        },

        fetchOptions() {
            this.$http
                .get('api/valuelookups/options/' + this.id)
                .then(({ data }) => {
                    this.machshipFields = []
                    data.machship_fields.sort()
                    this.machshipFields = data.machship_fields
                    this.selectField = this.machshipFields[0]
                })
        },

        onChangeNew(text, field, machship_field) {
            // validate text changed
            if (text == "") {
                return
            }

            let new_item = {
                _id: Math.random().toString(36).substring(7),
                from_value: '',
                from_label: '',
                to_value: '',
                to_label: '',
                integration_id: this.id,
                machship_field: machship_field
            };

            this.items[machship_field].push(Object.assign(new_item, {[field]: text}))
            this.refreshRows()
            this.$refs['new-' + machship_field + '-' + field][0].reset()
        },

        onSubmit(e) {
            e.preventDefault()
            if (this.$refs.form.validate()) {
                this.isSubmit = true
                this.$http
                    .post('/api/valuelookups/bulk', {
                        direction: this.direction,
                        items: this.items
                    })
                    .then(({ data }) => {
                        EventBus.$emit('show-success', 'Successfully saved value lookups.')
                        this.prepareMapItems(data)
                        this.isSubmit = false
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                        this.isSubmit = false
                    })
            }
        },

        onConfirmedClearRow(lookup) {
            return this.$http
                .post('api/valuelookups/removes',  [lookup.id])
                .then(res => {
                    const ms_field = lookup.machship_field
                    lookup.from_value = ""
                    lookup.from_label = ""
                    lookup.to_value = ""
                    lookup.to_label = ""
                    let index = this.items[ms_field].findIndex(item => item.id == lookup.id)
                    if (index >= 0) {
                        this.items[ms_field].splice(index, 1)
                    }
                    this.refreshRows()
                    EventBus.$emit('show-success', 'Successfully deleted single row lookup')
            })
        },

        onClearRow(lookup) {
            this.$refs.modal.onShow(
                'Delete Confirmation',
                'Are you sure you want this row?',
                () => { return this.onConfirmedClearRow(lookup) }
            );
        },

        refreshRows() {
            Vue.set(this.items, 'test', [])
            delete this.items['test']
        },

        fetchIntegration() {
            this.$http
            .get('/api/valuelookups/' + this.direction + '/' + this.id)
            .then(({ data }) => {
                this.prepareMapItems(data)
            })
            .catch(err => {
                EventBus.$emit('show-error', err);
            })
        },

        prepareMapItems(data) {
            this.items = {}
            // gives time for each item to render
            data.forEach((item, i) => {
                if (this.items[item.machship_field]) {
                    this.items[item.machship_field].push(item)
                } else {
                    // this.items.push(item.machship_field)
                    Object.assign(this.items, {[item.machship_field]: []})
                    this.items[item.machship_field].push(item)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .table-valuelookups-row {
        position: relative;
        &:hover .ic-remove { visibility: visible; }
        .ic-remove {
            visibility: hidden;
            position: absolute;
            right: 15px;
            top: 15px;
        }
    }
</style>